import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Button, Container, TabPane, Row, Col } from "reactstrap";
import { PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS } from "../../../../utils/constants";
import {
  errorNotification,
  infoNotification
} from "../../../../utils/notifications";
import { createPaymentLineForOnlineTokenization } from "../../../actions/partners";
import {
  deletePaymentLineRequest,
  getPaymentLineRequest
} from "../../../actions/paymentLines";
import IFrameContainer from "../../common/iframeContainer/iFrameContainer";
import { Partner } from "./../interfaces";
import PaymentMethodItem from "./paymentMethodItem";
import s from "./tabTokenization.scss";
import { errorOBNotification } from "../../../../OnBoardingUI/components/OBNotification/OBNotification.utils";
import { handleOBRequestError } from "../../../../utils/helpers";

interface Props {
  partner: Partner;
  idMembresiaSocio: any;
  paymentMethods: any[];
  loadingData: boolean;
  loadingDataMessage: String;
  getPaymentMethods: () => any;
  refreshPartner: () => void;
  invalidateStateValue: (fieldName: string, value: any) => void;
  plataforma: string;
}

class TabBankCards extends React.Component<Props> {
  state = {
    waiting: false,
    iFrameModalIsOpen: false,
    iFrameModalSrc: null,
    lineaPagoData: null
  };

  isMembershipPendienteTokenizacion = () => {
    return (
      !!this.props.partner &&
      [PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS].includes(
        this.props.partner.estatusMembresia
      )
    );
  };

  createPaymentLineForOnlineTokenization = () => {
    this.setState({ waiting: true });
    infoNotification("Generando pago en línea");

    const { idMembresiaSocio } = this.props;
    createPaymentLineForOnlineTokenization(
      idMembresiaSocio,
      this.props.plataforma
    )
      .then(({ data }) => {
        console.info(data);
        this.setState({ waiting: false });

        this.setState({
          lineaPagoData: data,
          iFrameModalSrc: data.url + "&onBoarding=true",
          iFrameModalIsOpen: true
        });
      })
      .catch(error => {
        this.setState({ waiting: false });
        handleOBRequestError(error);
      });
  };

  handleTokenizationWithOnlinePaymentClick = e => {
    e.preventDefault();
    this.createPaymentLineForOnlineTokenization();
  };

  render() {
    return (
      <TabPane className="my-2" tabId="1">
        <Container className="p-0 m-0">
          {/* Nombre del cliente */}
          <div style={{ marginLeft: "24px" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                marginBottom: "4px"
              }}
            >
              Nombre del cliente:
            </div>
            <div
              style={{
                fontSize: "12px",
                marginBottom: "10px"
              }}
            >
              {this.props.partner.nombrePersona}
            </div>
          </div>
          <hr />

          {/* Métodos de pago registrados */}
          {(this.props.paymentMethods || []).length > 0 &&
            !this.state.iFrameModalIsOpen &&
            (this.props.paymentMethods || []).map((pm, index) => (
              <PaymentMethodItem key={index} paymentMethod={pm} />
            ))}

          {/* Mensaje de cargos recurrentes */}
          {(this.props.paymentMethods || []).length == 0 &&
            !this.state.iFrameModalIsOpen && (
              <div
                className={`${s.infoCard} ${s.gray}`}
                style={{ margin: "0 24px 10px 24px" }}
              >
                Para poder validar que su tarjeta está habilitada para realizar
                cargo recurrente, se realizará un cargo inicial de $1 únicamente
                para fines de verificación.
              </div>
            )}

          {this.isMembershipPendienteTokenizacion() &&
            !this.state.iFrameModalIsOpen && (
              <div className="m-4">
                <Button
                  className="bg-secondary mr-4"
                  size="sm"
                  disabled={!!this.state.waiting}
                  block
                  onClick={this.handleTokenizationWithOnlinePaymentClick}
                >
                  Pagar en línea
                </Button>
              </div>
            )}

          {this.isMembershipPendienteTokenizacion() &&
            this.state.iFrameModalIsOpen && (
              <IFrameContainer
                title={"Tokenización con pago en línea"}
                okTitle={"Procesar pago"}
                waiting={this.state.waiting}
                ok={() => {
                  const { idMembresiaSocio } = this.props;
                  const { lineaPagoData } = this.state;
                  this.setState({ waiting: true });

                  setTimeout(() => {
                    getPaymentLineRequest(lineaPagoData.id)
                      .then(({ data: lp }) => {
                        if (
                          ["COBRADA_MIT", "FACTURADA"].includes(
                            lp.estatus || ""
                          )
                        ) {
                          this.setState({
                            iFrameModalSrc: null,
                            iFrameModalIsOpen: false,
                            lineaPagoData: null,
                            waiting: false
                          });

                          this.props.invalidateStateValue("paymentMethods", []);
                          this.props.getPaymentMethods();
                          this.props.refreshPartner();
                        } else {
                          errorOBNotification(
                            "¡Ooops! Aún no detectamos tu pago, intenta de nuevo por favor."
                          );
                          this.setState({ waiting: false });
                        }
                      })
                      .catch(error => {
                        this.setState({ waiting: false });
                        errorOBNotification(
                          "¡Ooops! Aún no detectamos tu pago, intenta de nuevo por favor."
                        );
                      });
                  }, 8000);

                  // markPaymentLineAsCompleted(idMembresiaSocio, lineaPagoData)
                  //   .then(() => {
                  //     this.setState({
                  //       iFrameModalSrc: null,
                  //       iFrameModalIsOpen: false,
                  //       lineaPagoData: null,
                  //       waiting: false
                  //     });

                  //     this.props.invalidateStateValue("paymentMethods", []);
                  //     this.props.getPaymentMethods();
                  //     this.props.refreshPartner();
                  //   })
                  //   .catch(error => {
                  //     this.setState({ waiting: false });
                  //     handleOBRequestError(error);
                  //   });
                }}
                cancel={() => {
                  const { lineaPagoData } = this.state;
                  this.setState({ waiting: true });

                  deletePaymentLineRequest(lineaPagoData.id)
                    .then(() => {
                      this.setState({
                        iFrameModalSrc: null,
                        iFrameModalIsOpen: false,
                        lineaPagoData: null,
                        waiting: false
                      });
                    })
                    .catch(error => {
                      this.setState({ waiting: false });
                      handleOBRequestError(error);
                    });
                }}
                src={this.state.iFrameModalSrc}
              />
            )}
        </Container>
      </TabPane>
    );
  }
}
export default withStyles(s)(TabBankCards);
